import { Group } from "@fairfleet/geotab";
import { DEFAULT_GROUP_COLOR, GroupColor } from "@/hooks/groups/useAddOrUpdateGroup";

export const GROUP_COLORS: GroupColor[] = [
  DEFAULT_GROUP_COLOR,
  { r: 255, g: 165, b: 0, a: 255 },
  { r: 0, g: 128, b: 0, a: 255 },
  { r: 230, g: 230, b: 0, a: 255 },
  { r: 173, g: 216, b: 230, a: 255 },
  { r: 0, g: 0, b: 255, a: 255 },
  { r: 128, g: 0, b: 128, a: 255 },
];

export function toGroupColor(group: Group | null | undefined): GroupColor {
  return {
    r: group?.color?.r ?? DEFAULT_GROUP_COLOR.r,
    g: group?.color?.g ?? DEFAULT_GROUP_COLOR.g,
    b: group?.color?.b ?? DEFAULT_GROUP_COLOR.b,
    a: group?.color?.a ?? DEFAULT_GROUP_COLOR.a,
  };
}

export function colorToCss(color: GroupColor): string {
  return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a / 255})`;
}

export function sameColor(left: GroupColor, right: GroupColor): boolean {
  return left.r === right.r && left.g === right.g && left.b === right.b && left.a === right.a;
}
